import { Edge, LeafNode, GroupNode, Model, BaseInstance, NodeType } from './types';
import { ShaderLocationsVault } from '%COMMON/ShaderLocationsVault';
import { mat4 } from 'gl-matrix';
import { Stack } from '%COMMON/Stack';
import {
  generateCubeInstance,
  generateCylinderInstance, generateFanInstance,
  generateSemisphereInstance,
  generateSphereInstance
} from './BaseInstance';

/**
 * Renders the bitch
 */
export class Renderer {
  private readonly idToInstance: BaseInstance[];
  private readonly gl: WebGLRenderingContext;
  private readonly shaderLocations: ShaderLocationsVault;
  private readonly proj: mat4;

  constructor(gl: WebGLRenderingContext, shaderLocations: ShaderLocationsVault, proj: mat4) {
    this.gl = gl;
    this.idToInstance = [
      generateCubeInstance(gl),
      generateCylinderInstance(gl),
      generateSphereInstance(gl),
      generateSemisphereInstance(gl),
      generateFanInstance(gl),
    ]
    this.shaderLocations = shaderLocations;
    this.proj = proj;
  }


/**
 *
 */
private renderLeafNode(modelView: mat4, leafNode: LeafNode) {
  const modelViewLoc = this.shaderLocations.getUniformLocation("modelview");
  const projLoc = this.shaderLocations.getUniformLocation("proj");
  const colorLoc = this.shaderLocations.getUniformLocation("vColor");
  const posLoc = this.shaderLocations.getAttribLocation("vPosition");

  const instance = this.idToInstance[leafNode.instance]

  this.gl.bindBuffer(this.gl.ARRAY_BUFFER, instance.vbo);
  this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, instance.ibo);
  this.gl.uniformMatrix4fv(modelViewLoc, false, modelView);
  this.gl.uniform4fv(colorLoc, leafNode.color);
  this.gl.uniformMatrix4fv(projLoc, false, this.proj);
  this.gl.vertexAttribPointer(posLoc, 3, this.gl.FLOAT, false, 0, 0);
  this.gl.enableVertexAttribArray(posLoc);
  this.gl.drawElements(this.gl.TRIANGLES, instance.numIndices, this.gl.UNSIGNED_SHORT, 0);
};

/**
 * 
 */
private renderGroupNode(modelView: mat4, groupNode: GroupNode) {
  groupNode.edges.forEach((edge: Edge) => {
    const childMatrix: mat4 = mat4.clone(modelView);
    edge.transformation && mat4.multiply(childMatrix, childMatrix, edge.transformation);
    this.renderNode(childMatrix, edge.to, edge.toType);
  });
};

/**
 * 
 */
private renderNode(modelView: mat4, node: GroupNode | LeafNode, nodeType: NodeType) {
  if (nodeType === NodeType.GROUP_NODE) {
    this.renderGroupNode(modelView, node as GroupNode);
  } else {
    this.renderLeafNode(modelView, node as LeafNode);
  }
}

/**
 * 
 */
public render(modelView: mat4, model: Model): void {
  this.renderNode(modelView, model.scene, model.sceneNodeType);
};
}
